export default __webpack_public_path__ + "static/media/SignIni.37b4dd26.svg";